var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"mention-menu elevation-4",attrs:{"id":"mention-menu","role":"listbox"}})
}
var staticRenderFns = []

export { render, staticRenderFns }